export const getClasses = (classesObj: {[key: string]: boolean}) => Object.keys(classesObj).filter(key => classesObj[key]).join(' ');